import React from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";


export default function Layout({ children }) {
  return (

    <>
    <Header/>
    <div style={{maxWidth:"100%", paddingTop: "100px",}} className="main-content">


      {children}
    </div>
    <Footer/>
    </>
    

  );
}
